import * as ReactDOMClient from "react-dom/client";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

import "./assets/scss/custom.scss";
import App from "./App";
import { AuthContextProvider } from "store/auth-context";
import customerStore from "store/customer-store";
import filterStore from "store/category-filter-store";

const container = document.getElementById("root");

// Create a root.
const root = ReactDOMClient.createRoot(container);

customerStore();
filterStore();

// Keep the layout height in sync when the browser window changes size.
const updateViewportHeight = () => {
    document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
};

updateViewportHeight();
window.addEventListener("resize", updateViewportHeight);

// Initialize React Query
const queryClient = new QueryClient();

// Assert sure base URL for the API set
if (process.env.REACT_APP_URL) {
    // Initial render: Render an element to the root.
    root.render(
        <QueryClientProvider client={queryClient}>
            <AuthContextProvider>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
            </AuthContextProvider>
        </QueryClientProvider>
    );
} else {
    root.render(<h1>Required env variable is not set: REACT_APP_URL</h1>, document.getElementById("root"));
}
